import React from "react";
import {translator} from "core/localization/localization";
import {ModalWindow} from "controls/modalWindow";
import AssetForm from "areas/administration/assetForm";
import {AddButton} from "controls/react/windows/addButton";


const i = translator({
  "Create new asset": {
    "no": "Opprett ny ressurs",
    "en": "Create new asset"
  },
  "Create asset": {
    "no": "Lag ressurs",
    "en": "Create asset"
  }
});

export class AddAsset extends React.PureComponent {
	render() {
		return <AddButton className={this.props.containerClass}
		                  label={i('Create new asset')}
		                  onClick={() => this.onClick()}
		                  disabled={this.props.disabled} />;
	}
	onCreateNew = (newAssetId) => {
		this.props?.onCreateNew(newAssetId);
	}
	onClick() {
		this.window = new ModalWindow({
			title: i('Create asset'),
			width: 400,
			minHeight: 567,
			height: 'auto',
			url: 'include/Administration/AssetForm.jsp',
			refresh: () => {
				new AssetForm({
					id: this.props.assetId || null,
					mode: this.props.assetId ? 'update': 'create',
					accountId: this.props.accountId,
					identifier: this.props.identifier,
					onCreateNew: this.onCreateNew
				});
			},
			onClose: () => {
				if (this.props.onClose) {
					this.props.onClose();
				}
			}
		});
		this.window.open();
	}
}

export default AddAsset;
